import _defineProperty2 from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { TranslatorContext } from '@jutro/locale';
import { intlMessageShape, tooltipBaseProps, deprecated, placementOptions } from '@jutro/prop-types';
import { ContextConsumer, getMessageProp } from '@jutro/platform';
import { TooltipContent } from './TooltipContent';
import styles from "./TooltipIcon.module.css";
import { Tooltip } from './Tooltip';
import { Icon } from '../Icon/Icon';
import { messages } from './TooltipIcon.messages';
export let TooltipIcon = function (_React$Component) {
  _inherits(TooltipIcon, _React$Component);
  var _super = _createSuper(TooltipIcon);
  function TooltipIcon(props) {
    var _this;
    _classCallCheck(this, TooltipIcon);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", event => {
      if (_this.iconRef && _this.tooltip && !_this.tooltip.popper.contains(event.target) && !_this.iconRef.current.contains(event.target)) {
        _this.hideTooltip();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getOpenIcon", icon => `${icon}`);
    _defineProperty(_assertThisInitialized(_this), "getClosedIcon", icon => `${icon}-outline`);
    _defineProperty(_assertThisInitialized(_this), "setClosedIcon", async () => _this.setState({
      icon: _this.getClosedIcon(_this.props.icon)
    }));
    _defineProperty(_assertThisInitialized(_this), "setOpenIcon", async () => _this.setState({
      icon: _this.getOpenIcon(_this.props.icon)
    }));
    _defineProperty(_assertThisInitialized(_this), "toggleTooltip", evt => {
      evt.preventDefault();
      const _assertThisInitialize = _assertThisInitialized(_this),
        tooltip = _assertThisInitialize.tooltip,
        setClosedIcon = _assertThisInitialize.setClosedIcon,
        setOpenIcon = _assertThisInitialize.setOpenIcon;
      if (tooltip) {
        if (tooltip.state.isVisible) {
          setClosedIcon().then(tooltip.hide);
        } else {
          setOpenIcon().then(tooltip.show);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hideTooltip", () => {
      const _assertThisInitialize2 = _assertThisInitialized(_this),
        tooltip = _assertThisInitialize2.tooltip,
        setClosedIcon = _assertThisInitialize2.setClosedIcon;
      if (tooltip !== null && tooltip !== void 0 && tooltip.state.isVisible) {
        setClosedIcon().then(tooltip.hide);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getAccessibilityProperties", translator => {
      const messageProps = _this.props.messageProps;
      const showTooltipLabel = getMessageProp('showTooltip', messageProps, messages);
      return {
        'aria-label': translator(showTooltipLabel),
        'aria-haspopup': 'true'
      };
    });
    _defineProperty(_assertThisInitialized(_this), "renderComponent", translator => {
      const _this$props = _this.props,
        id = _this$props.id,
        text = _this$props.text,
        title = _this$props.title,
        link = _this$props.link,
        href = _this$props.href,
        renderContent = _this$props.renderContent,
        className = _this$props.className,
        placementProp = _this$props.placement,
        tipPlacement = _this$props.tipPlacement,
        flipBehavior = _this$props.flipBehavior,
        labelPosition = _this$props.labelPosition,
        showInlineLabel = _this$props.showInlineLabel;
      const placement = tipPlacement || placementProp;
      const icon = _this.state.icon;
      const content = renderContent ? renderContent() : React.createElement(TooltipContent, {
        title: title,
        text: text,
        href: href,
        link: link,
        translator: translator
      });
      const tooltipProps = {
        id,
        content,
        placement,
        trigger: 'manual',
        hideOnClick: false,
        flipBehavior
      };
      const classes = cx(styles.tooltipIcon, {
        [styles[labelPosition]]: !showInlineLabel
      }, className);
      return React.createElement(Tooltip, _extends({}, tooltipProps, {
        onCreate: tooltip => {
          _this.tooltip = tooltip;
        }
      }), React.createElement("button", _extends({
        ref: _this.iconRef,
        type: "button",
        onClick: _this.toggleTooltip,
        className: classes
      }, _this.getAccessibilityProperties(translator)), React.createElement(Icon, {
        icon: icon,
        "aria-hidden": "true"
      })));
    });
    _this.state = {
      icon: _this.getClosedIcon(props.icon)
    };
    _this.iconRef = React.createRef();
    return _this;
  }
  _createClass(TooltipIcon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(ContextConsumer, {
        contexts: [TranslatorContext]
      }, this.renderComponent);
    }
  }]);
  return TooltipIcon;
}(React.Component);
_defineProperty(TooltipIcon, "propTypes", _objectSpread({
  id: PropTypes.string.isRequired,
  icon: PropTypes.string
}, tooltipBaseProps, {
  tipPlacement: deprecated(PropTypes.string, '6.0.0', 'Use placement instead.'),
  placement: PropTypes.oneOf(placementOptions),
  className: PropTypes.string,
  messageProps: PropTypes.shape({
    showTooltip: intlMessageShape
  }),
  flipBehavior: PropTypes.array,
  labelPosition: PropTypes.oneOf(['top', 'left']),
  showInlineLabel: PropTypes.bool
}));
_defineProperty(TooltipIcon, "defaultProps", {
  icon: 'mi-help'
});
TooltipIcon.__docgenInfo = {
  componentName: "TooltipIcon",
  packageName: "@jutro/components",
  description: "",
  displayName: "TooltipIcon",
  methods: [{
    name: "handleClickOutside",
    docblock: "Handles clicking outside\n@param {Event} event",
    modifiers: [],
    params: [{
      name: "event",
      description: null,
      type: {
        name: "Event"
      },
      optional: false
    }],
    returns: null,
    description: "Handles clicking outside"
  }, {
    name: "getOpenIcon",
    docblock: "getOpenIcon\n@param {string} icon\n@returns {string}",
    modifiers: [],
    params: [{
      name: "icon",
      description: null,
      type: {
        name: "string"
      },
      optional: false
    }],
    returns: {
      description: null,
      type: {
        name: "string"
      }
    },
    description: "getOpenIcon"
  }, {
    name: "getClosedIcon",
    docblock: "getClosedIcon\n@param {string} icon\n@returns {string}",
    modifiers: [],
    params: [{
      name: "icon",
      description: null,
      type: {
        name: "string"
      },
      optional: false
    }],
    returns: {
      description: null,
      type: {
        name: "string"
      }
    },
    description: "getClosedIcon"
  }, {
    name: "setClosedIcon",
    docblock: null,
    modifiers: ["async"],
    params: [],
    returns: null
  }, {
    name: "setOpenIcon",
    docblock: null,
    modifiers: ["async"],
    params: [],
    returns: null
  }, {
    name: "toggleTooltip",
    docblock: "toggleTooltip\n@param {Event} evt",
    modifiers: [],
    params: [{
      name: "evt",
      description: null,
      type: {
        name: "Event"
      },
      optional: false
    }],
    returns: null,
    description: "toggleTooltip"
  }, {
    name: "hideTooltip",
    docblock: null,
    modifiers: [],
    params: [],
    returns: null
  }, {
    name: "getAccessibilityProperties",
    docblock: "Returns accessibility properties for tooltip icon button\n\n@param {Function} translator function used to translate the message\n@returns {object} object containing accessibility properties",
    modifiers: [],
    params: [{
      name: "translator",
      description: "function used to translate the message",
      type: {
        name: "Function"
      },
      optional: false
    }],
    returns: {
      description: "object containing accessibility properties",
      type: {
        name: "object"
      }
    },
    description: "Returns accessibility properties for tooltip icon button"
  }, {
    name: "renderComponent",
    docblock: "Render tooltip icon\n\n@param {Function} translator function to translate strings\n@returns {React.ReactElement} tooltip icon",
    modifiers: [],
    params: [{
      name: "translator",
      description: "function to translate strings",
      type: {
        name: "Function"
      },
      optional: false
    }],
    returns: {
      description: "tooltip icon",
      type: {
        name: "React.ReactElement"
      }
    },
    description: "Render tooltip icon"
  }],
  actualName: "TooltipIcon",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: true,
      description: "Used to identify the component. Referenced to find it in the document tree"
    },
    icon: {
      type: {
        name: "string"
      },
      required: false,
      description: "Icon to be displayed",
      defaultValue: {
        value: "'mi-help'",
        computed: false
      }
    },
    tipPlacement: {
      type: {
        name: "string"
      },
      required: false,
      description: "@deprecated Position of the tooltip in relation to icon",
      deprecationInfo: {
        version: "6.0.0",
        mapTo: null
      }
    },
    placement: {
      type: {
        name: "enum",
        computed: true,
        value: "placementOptions"
      },
      required: false,
      description: "Positions of the tooltip relative to its reference element (icon)"
    },
    className: {
      type: {
        name: "string"
      },
      required: false,
      description: "Additional class names for component."
    },
    messageProps: {
      type: {
        name: "shape",
        value: {
          showTooltip: {
            name: "union",
            required: false,
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: false
                },
                defaultMessage: {
                  name: "string",
                  required: false
                },
                args: {
                  name: "shape",
                  value: {},
                  required: false
                }
              }
            }]
          }
        }
      },
      required: false,
      description: "Message props(error message/aria-label)"
    },
    flipBehavior: {
      type: {
        name: "array"
      },
      required: false,
      description: "Determines the order of flipping of tooltip, i.e. which placements to prefer if a certain placement cannot be used"
    },
    labelPosition: {
      type: {
        name: "enum",
        value: [{
          value: "'top'",
          computed: false
        }, {
          value: "'left'",
          computed: false
        }]
      },
      required: false,
      description: "Information from Field Component to the Tooltip Icon about the whole label position"
    },
    showInlineLabel: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Information from Field Component. If true, label is displayed inline"
    }
  },
  composes: ["@jutro/prop-types"]
};